"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTreeNodeItem = exports.StyledSearchInput = exports.StyledTreeNodesSection = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTreeNodesSection = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;
  flex: 1;

  .tree-nodes-section-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .action-clear-selection {
      &.MuiButton-text.button--error.Mui-disabled {
        color: ${({ theme }) => theme.palette.action.disabled};
      }
    }
  }

  .tree-nodes-section-list {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
    flex: 1;
    overflow: auto;
  }

  .no-data-text {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
// TODO: create a separate component
exports.StyledSearchInput = (0, styled_components_1.default)(material_1.OutlinedInput) `
  && {
    height: 48px;
    min-width: 260px;
    flex-basis: fill;
    border-radius: 4px;

    &:hover .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[200]};
      border-width: 1px;
    }
  }
`;
exports.StyledTreeNodeItem = styled_components_1.default.div `
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.accent.main};
  gap: ${({ theme }) => theme.spacing(0.5)};
`;
